import { render, staticRenderFns } from "./SideMenuLinkSP.vue?vue&type=template&id=52e7f45b&scoped=true&"
import script from "./SideMenuLinkSP.vue?vue&type=script&lang=ts&"
export * from "./SideMenuLinkSP.vue?vue&type=script&lang=ts&"
import style0 from "./SideMenuLinkSP.vue?vue&type=style&index=0&id=52e7f45b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e7f45b",
  null
  
)

export default component.exports